import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-failed-moved-contacts-dialog',
  templateUrl: './failed-moved-contacts-dialog.component.html',
  styleUrls: ['./failed-moved-contacts-dialog.component.scss']
})
export class FailedMovedContactsDialogComponent implements OnInit {

  failed: {contact_id: number, message: string}[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
